import ApiResponse from "@/models/ApiResponse";
import http, { handleApiResponse } from "@/services/http";
import Transaction from "../models/Transaction";
import Country from "@/modules/cashPoint/models/Country";
import TransactionItem from "../models/TransactionItem";
import TransactionItemDimension from "../models/TransactionItemDimension";
import UserSetting from "../models/UserSetting";
import { TransactionItemInvoiceDocumentsDTO } from "../models/TransactionItemInvoiceDocuments";
import BookAuditItem from "../models/BookAuditItem";
import ValidationResult from "../models/ValidationResult";
// import { TransactionItemDimensions } from "../models/TransactionItemDimension";

export default class TransactionApi {

  //---------- Tranzakciók ----------//

  static getTransaction(id: number): Promise<Transaction> {
    return http.get<ApiResponse<Transaction>>(`general-ledger-transaction/transactions/${id}`)
      .then(handleApiResponse);
  }

  static save(id: number, head: Transaction): Promise<number> {
    return http.put<ApiResponse<number>>(`general-ledger-transaction/transactions/edit/${id}`, { head }).then(handleApiResponse);
  }
  
  //---------- Tranzakció tételek ----------//

  static getTransactionItems(id: number): Promise<TransactionItem[]> {
    return http.get<ApiResponse<TransactionItem[]>>(`general-ledger-transaction/transactions/${id}/items`)
      .then(handleApiResponse);
  }

  static saveTransItems(itemsArray: TransactionItem[]): Promise<number>{
    return http.post<ApiResponse<number>>("general-ledger-transaction/transaction-items/save", itemsArray).then(handleApiResponse);
  }

  static deleteTransItems(itemsArray: number[]): Promise<number>{
      return http.post<ApiResponse<number>>("general-ledger-transaction/transaction-items/delete",itemsArray).then(handleApiResponse);
  }

  //---------- Tranzakció tétel dimenziói ----------//
  
  static getTransactionDimensions(itemHeadList: number[]): Promise<TransactionItemDimension[]> {
    return http.post<ApiResponse<TransactionItemDimension[]>>("general-ledger-transaction/transactions/dimensions",itemHeadList)
      .then(handleApiResponse);
  }
  static saveTransDimItems(itemsArray: TransactionItemDimension[]): Promise<number>{
    return http.post<ApiResponse<number>>("general-ledger-transaction/transaction-dimensions/save", itemsArray).then(handleApiResponse);
  }
  static deleteTransDimItems(itemsArray: number[]): Promise<number>{
      return http.post<ApiResponse<number>>("general-ledger-transaction/transaction-dimensions/delete",itemsArray).then(handleApiResponse);
  }

  //---------- Egyéb ----------//
  static getAccGroup(): Promise<any[]> {
    return http.get<ApiResponse<any[]>>("general-ledger-transaction/detail/accgroup").then(handleApiResponse);
  }
  static getTools(): Promise<any[]> {
    return http.get<ApiResponse<any[]>>("general-ledger-transaction/detail/tools").then(handleApiResponse);
  }
  static getUsers(): Promise<any[]> {
    return http.get<ApiResponse<any[]>>("general-ledger-transaction/detail/users").then(handleApiResponse);
  }
  static getStations(): Promise<any[]> {
    return http.get<ApiResponse<any[]>>("general-ledger-transaction/detail/stations").then(handleApiResponse);
  }
  static getTransStats(): Promise<any[]> {
    return http.get<ApiResponse<any[]>>("general-ledger-transaction/detail/trans-stats").then(handleApiResponse);
  }
  static getTransTypes(): Promise<any[]> {
    return http.get<ApiResponse<any[]>>("general-ledger-transaction/detail/trans-types").then(handleApiResponse);
  }
  static getCurrencies(): Promise<Country[]> {
    return http.get<ApiResponse<Country[]>>("currency").then(handleApiResponse);
  }
  static getPeriods(year: string): Promise<any[]> {
    return http.get<ApiResponse<any[]>>(`general-ledger-transaction/head/periods/${Number(year.split("-")[0])}`).then(handleApiResponse);
  }
  static getPeriod(date: string): Promise<any[]>{
    return http.get<ApiResponse<any[]>>(`general-ledger-transaction/head/period/${date}`).then(handleApiResponse);
  }
  static getBookTypes(): Promise<any[]> {
    return http.get<ApiResponse<any[]>>("general-ledger-transaction/detail/book-types").then(handleApiResponse);
  }
  static getInvoiceMirrors(year: string): Promise<any[]> {
    return http.get<ApiResponse<any[]>>(`general-ledger-transaction/detail/invoice-mirror/${Number(year.split("-")[0])}`).then(handleApiResponse);
  }  
  static getDimensions(year: string): Promise<any[]> {
    return http.get<ApiResponse<any[]>>(`general-ledger-transaction/detail/dimension/${Number(year.split("-")[0])}`).then(handleApiResponse);
  } 
  static getCars(): Promise<any[]> {
    return http.get<ApiResponse<any[]>>("general-ledger-transaction/detail/cars").then(handleApiResponse);
  }
  static getProjects(): Promise<any[]> {
    return http.get<ApiResponse<any[]>>("general-ledger-transaction/detail/projects").then(handleApiResponse);
  } 
  static getPOs(): Promise<any[]> {
    return http.get<ApiResponse<any[]>>("general-ledger-transaction/detail/pos").then(handleApiResponse);
  }
  static validPartCode(partCode: string): Promise<any[]> {
    return http.post<ApiResponse<any[]>>(`general-ledger-transaction/validate/part/${partCode}`).then(handleApiResponse);
  }
  static validPartnerName(partnerName: string): Promise<any[]> {
    return http.post<ApiResponse<any[]>>(`general-ledger-transaction/validate/partner/${partnerName}`).then(handleApiResponse);
  } 
  static loadUserSetting(setting: any): Promise<UserSetting[]> {
    return http.post<ApiResponse<UserSetting[]>>(`general-ledger-transaction/setting/get-user-setting/`,setting).then(handleApiResponse);
  }
  static setUserSetting(setting: any): Promise<string> {
    return http.post<ApiResponse<string>>(`general-ledger-transaction/setting/set-user-setting/`, setting).then(handleApiResponse);
  }  
  static getInvoiceDocuments(invoiceNumber: number): Promise<TransactionItemInvoiceDocumentsDTO[]> {
    return http.get<ApiResponse<TransactionItemInvoiceDocumentsDTO[]>>(`general-ledger-transaction/detail/invoice-documents/${invoiceNumber}`).then(handleApiResponse);
  }
  static generateXML(item: BookAuditItem){
    return http.post("general-ledger-transaction/generate-xml",{data: item}).then(handleApiResponse);
  }

  static openXMLFile(path: string){
    return http.post("general-ledger-transaction/open-xml-file", JSON.stringify(path), {
      headers: {
          "Content-Type": "application/json"
      }
    });
  }

  //---------- Ellentételezés (Javítás) ----------//
  // mode: "K" = ellentett kontírozás (T/K fordítás), "O" = ellentett összeg (összeg-negálás)
  static reverseTransactions(mode: string, transIds: number[], accDate: string): Promise<ValidationResult[]> {
    return http.post<ApiResponse<ValidationResult[]>>(`general-ledger-transaction/transactions/reverse/${mode}`, { transIds, accDate }).then(handleApiResponse);
  }

}